<template>
  <div class="events">
    <div class="events_section" id="events">
      <div class="events_section_container">
        <div class="events_section_container_event">
          <img class="events_section_container_event_img" :src=" larps[2].img ">
          <h1 class="events_section_container_event_title">
            {{ larps[2].title }}
          </h1>
          <p class="events_section_container_event_descriptio">
            Frakcja: {{ larps[2].fraction }}<br />
            Cel: {{ larps[2].target }} <br /><br />
            {{ larps[2].description }}
          </p>
        </div>
      </div>

      <div class="events_section_container">
        <div class="events_section_container_event">
          <img class="events_section_container_event_img" :src=" larps[1].img ">
          <h1 class="events_section_container_event_title">
            {{ larps[1].title }}
          </h1>
          <p class="events_section_container_event_descriptio">
            Frakcja: {{ larps[1].fraction }}<br />
            Cel: {{ larps[1].target }} <br /><br />
            {{ larps[1].description }}
          </p>
        </div>
      </div>

      <div class="events_section_container">
        <div class="events_section_container_event">
          <img class="events_section_container_event_img" :src=" larps[0].img ">
          <h1 class="events_section_container_event_title">
            {{ larps[0].title }}
          </h1>
          <p class="events_section_container_event_descriptio">
            Frakcja: {{ larps[0].fraction }}<br />
            Cel: {{ larps[0].target }} <br /><br />
            {{ larps[0].description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import dataJson from '../../../static/json/data.json'

  export default{
    data () {
      return {
        larps: dataJson.events
      }
    }
  }

</script>

<style lang="scss">
  @import 'events';
</style>



// WEBPACK FOOTER //
// events.vue?634c3bc2